"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Shield, Zap, Trophy, ChevronLeft, ChevronRight } from "lucide-react";
const slide_content = [{
  title: "PREMIUM RMT & PRO BOOSTING",
  subtitle: "Instant Delivery • Secure Trading",
  description: "Experience the elite tier of gaming services with our guaranteed secure delivery systems.",
  image: "https://p2wstore.com/wp-content/uploads/2026/04/1.png?v=87f2r12hgoa",
  srcset: "https://p2wstore.com/wp-content/uploads/2026/04/1.png?v=53x778c9ctg-wvc-srcset",
  sizes: "https://p2wstore.com/wp-content/uploads/2026/04/1.png?v=6knszk77vu6-wvc-sizes",
  accent: "text-primary",
  icon: <Trophy className="w-6 h-6 text-primary" />
}, {
  title: "MULTI-GAME BOOSTING",
  subtitle: "League • Valorant • MLBB • Genshin • Roblox & More",
  description: "Professional rank pushing across all major titles. Our boosters are top 0.1% globally.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/hero_multigame_grid.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/hero_multigame_grid.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/hero_multigame_grid.png-wvc-sizes",
  accent: "text-accent-foreground",
  icon: <Zap className="w-6 h-6 text-accent-foreground" />
}, {
  title: "TRUSTED • FAST • RELIABLE",
  subtitle: "Farm Directly • No Reseller • 24/7 Support",
  description: "Direct access to professional farmers. No middleman, no extra fees, just pure speed.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/hero_trusted_speed.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/hero_trusted_speed.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642964/img/hero_trusted_speed.png-wvc-sizes",
  accent: "text-primary",
  icon: <Shield className="text-primary w-6 h-6" />
}];
export default function GameBannerShowcase() {
  const [current_slide_index, setCurrentSlideIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentSlideIndex(prev => (prev + 1) % slide_content.length);
    }, 6000);
    return () => clearInterval(intervalId);
  }, []);
  const handlePrev = () => {
    setCurrentSlideIndex(prev => (prev - 1 + slide_content.length) % slide_content.length);
  };
  const handleNext = () => {
    setCurrentSlideIndex(prev => (prev + 1) % slide_content.length);
  };
  return <section id="gamebannershowcase" className="relative w-full bg-secondary overflow-hidden min-h-[300px] flex items-center !h-[300px]">
      {}
      <div className="absolute inset-0 pointer-events-none z-10 opacity-5 bg-[linear-gradient(to_bottom,transparent_50%,black_50%)] bg-[length:100%_4px] animate-[pulse_4s_infinite]" />
      
      {}
      <div className="absolute top-8 right-8 z-30">
        <Link to="/">
          <img src="https://p2wstore.com/wp-content/uploads/2026/04/logo-1.png" alt="P2W Logo" className="h-10 md:h-12 drop-shadow-[0_0_10px_rgba(59,130,246,0.5)]" />
        </Link>
      </div>

      <div className="coverflow-container perspective-[1200px] relative w-full h-full flex items-center justify-center py-20">
        <div className="relative w-full max-w-6xl h-[250px] flex items-center justify-center">
          {slide_content.map((slide, i) => {
          const offset = i - current_slide_index;
          const isActive = i === current_slide_index;
          const isPrev = i === (current_slide_index - 1 + slide_content.length) % slide_content.length;
          const isNext = i === (current_slide_index + 1) % slide_content.length;
          let transform = "translateZ(-400px) opacity-0 scale-75";
          let zIndex = 0;
          if (isActive) {
            transform = "translateZ(0px) translateX(0) rotateY(0deg) scale(1)";
            zIndex = 20;
          } else if (isPrev) {
            transform = "translateX(-60%) translateZ(-200px) rotateY(35deg) scale(0.85)";
            zIndex = 10;
          } else if (isNext) {
            transform = "translateX(60%) translateZ(-200px) rotateY(-35deg) scale(0.85)";
            zIndex = 10;
          }
          return <div key={i} data-index={i} onClick={() => !isActive && setCurrentSlideIndex(i)} className={`absolute inset-0 transition-all duration-700 ease-out flex items-center justify-center ${!isActive ? "cursor-pointer hover:brightness-110" : ""}`} style={{
            transform,
            zIndex,
            transformStyle: "preserve-3d"
          }}>
                <div className={`relative w-full h-full overflow-hidden rounded-lg border border-white/10 ${isActive ? "shadow-[0_0_40px_rgba(59,130,246,0.3)]" : "shadow-xl"}`}>
                  {}
                  <div className="absolute inset-0 z-0">
                    <img src={slide.image} data-wvc-srcset={slide.srcset} data-wvc-sizes={slide.sizes} alt={slide.title} className="object-cover object-center w-full h-full" loading={i === 0 ? "eager" : "lazy"} />
                    <div className="absolute inset-0 bg-gradient-to-r from-background via-background/60 to-transparent" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
                  </div>

                  {}
                  {isActive && <div className="container relative z-20 mx-auto px-6 md:px-12 h-full flex items-center">
                      <div className="max-w-2xl space-y-6">
                        

                        

                        

                        <div className="flex flex-wrap gap-4 pt-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
                          
                          
                        </div>
                      </div>
                    </div>}
                </div>
              </div>;
        })}
        </div>

        {}
        <div className="absolute bottom-12 right-12 z-30 flex items-center gap-4">
          <div className="flex gap-2 mr-4">
            {slide_content.map((_, i) => <button key={i} onClick={() => setCurrentSlideIndex(i)} className={`h-1.5 transition-all duration-300 rounded-full ${current_slide_index === i ? "w-8 bg-primary shadow-[0_0_15px_rgba(59,130,246,0.8)]" : "w-2 bg-muted-foreground/30"}`} aria-label={`Go to slide ${i + 1}`} />)}
          </div>
          
          <div className="flex gap-2">
            
            
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />
    </section>;
}